import OnboardingContainerOne from './OnboardingContainerOne';
import OnboardingContainerTwo from './OnboardingContainerTwo';

export {
    OnboardingContainerOne,
    OnboardingContainerTwo
}